(function () {
    "use strict";

    if (window.hotelSortListenerAdded) return;
    window.hotelSortListenerAdded = true;

    const HIDDEN_CLASS = "d-none";
    const SORT_FORM_SELECTOR = ".hotel-sort-form";
    const SORT_BUTTON_SELECTOR = ".sort-option-btn";
    const POLL_TARGET_IDS = ["search-poll-div", "collection-poll-div"];

    function updateSortBadges() {
        const hasSort = !!document.querySelector(SORT_BUTTON_SELECTOR + '[aria-pressed="true"]');
        document.querySelectorAll(".sort-active-badge").forEach(function (badge) {
            badge.classList.toggle(HIDDEN_CLASS, !hasSort);
        });
    }

    function pushSortSelectionDatalayer(button) {
        if (!button || typeof push_to_datalayer !== "function") return;

        const sortKey = button.getAttribute("data-sort-value");
        if (!sortKey) return;

        push_to_datalayer({
            event: "hotel_sort_list",
            sort_type: [sortKey],
        });
    }

    function onSortButtonClick(event) {
        const button = event.target.closest(SORT_BUTTON_SELECTOR);
        if (!button || button.disabled) return;

        const form = button.closest(SORT_FORM_SELECTOR);
        if (!form) return;

        pushSortSelectionDatalayer(button);

        form.querySelectorAll(SORT_BUTTON_SELECTOR).forEach(function (option) {
            option.removeAttribute("data-sort-loading");
        });
        button.setAttribute("data-sort-loading", "true");
    }

    function isPollTarget(target) {
        return !!(target && target.id && POLL_TARGET_IDS.indexOf(target.id) !== -1);
    }

    function onHtmxBeforeSwap(event) {
        if (!isPollTarget(event.detail && event.detail.target)) return;
        if (kombi.closeOffcanvas) kombi.closeOffcanvas("offcanvasSort");
        if (kombi.closeModal) kombi.closeModal("sortModal");
    }

    function cleanupOrphanBackdrops() {
        document.body.classList.remove("modal-open");
        document.body.style.overflow = "";
        document.body.style.paddingRight = "";
        document.querySelectorAll(".modal-backdrop, .offcanvas-backdrop").forEach(function (backdrop) {
            backdrop.remove();
        });
    }

    function onHtmxAfterSettle(event) {
        if (isPollTarget(event.detail && event.detail.target)) {
            cleanupOrphanBackdrops();
        }
        updateSortBadges();
    }

    function isSortFormRequest(event) {
        const elt = event.detail && event.detail.elt;
        return !!(elt && elt.closest && elt.closest(SORT_FORM_SELECTOR));
    }

    function resetSortLoading(form) {
        const scope = form && form.querySelectorAll ? form : document;
        scope.querySelectorAll(SORT_BUTTON_SELECTOR).forEach(function (option) {
            option.removeAttribute("data-sort-loading");
        });
    }

    function onHtmxAfterRequest(event) {
        if (!isSortFormRequest(event)) return;
        const successful = event.detail && event.detail.successful;
        if (!successful) {
            resetSortLoading(event.detail && event.detail.elt && event.detail.elt.closest(SORT_FORM_SELECTOR));
        }
    }

    document.addEventListener("click", onSortButtonClick);
    document.addEventListener("htmx:beforeSwap", onHtmxBeforeSwap);
    document.addEventListener("htmx:afterSettle", onHtmxAfterSettle);
    document.addEventListener("htmx:afterRequest", onHtmxAfterRequest);

    updateSortBadges();
})();

kombi.hotel = function (root) {
    const scope = root || document;
    scope.querySelectorAll(".toggleRoomsLink").forEach(function (toggleLink) {
        if (kombi.lifecycle.isInitialized(toggleLink, "room-toggle")) {
            return;
        }
        const targetId = toggleLink.getAttribute("href");
        if (!targetId) return;

        const collapseElement =
            scope.querySelector(targetId) || document.querySelector(targetId);
        if (!collapseElement) return;

        collapseElement.addEventListener("shown.bs.collapse", function () {
            toggleLink.textContent = "Ver menos quartos";
        });

        collapseElement.addEventListener("hidden.bs.collapse", function () {
            toggleLink.textContent = "Ver mais quartos";
        });
        kombi.lifecycle.markInitialized(toggleLink, "room-toggle");
    });
};

(function () {
    const PACKAGE_POST_RESULTS_SKELETON_MS = 2000;

    kombi.packageSearchPollingLoader = function () {
        const polls = [...document.querySelectorAll('#search-poll-div[data-package-flight-poll-loader="1"]')];
        if (polls.length === 0) {
            return;
        }
        polls.forEach(function (pollDiv) {
            if (kombi.flight && kombi.flight.initLoaderTextRotation) {
                kombi.flight.initLoaderTextRotation(pollDiv);
            }
        });
    };

    function revealPackageSearchPostResultsSkeleton(root) {
        if (!root || root.getAttribute("data-package-post-results-skeleton") !== "1") {
            return;
        }
        window.setTimeout(function () {
            const live = document.getElementById("search-poll-div");
            if (!live || live.getAttribute("data-package-post-results-skeleton") !== "1") {
                return;
            }
            const skeleton = live.querySelector(".package-search-post-results-skeleton");
            const panel = live.querySelector(".hotel-search-results-panel");
            if (!skeleton || !panel) {
                return;
            }
            skeleton.classList.add("d-none");
            panel.classList.remove("d-none");
            live.removeAttribute("data-package-post-results-skeleton");
        }, PACKAGE_POST_RESULTS_SKELETON_MS);
    }

    // outerHTML swap: event.detail.target is the replaced (detached) node.
    // Always resolve #search-poll-div from the live DOM for skeleton reveal.
    kombi.lifecycle.onBody(
        "htmx:afterSwap",
        function () {
            kombi.packageSearchPollingLoader();
            const root = document.getElementById("search-poll-div");
            if (root) {
                revealPackageSearchPostResultsSkeleton(root);
            }
        },
        { targetId: "search-poll-div", onceKey: "hotel-package-poll" }
    );
})();
